export const checkIfUrlStartsWithMailto = (url: string) => {
    return (url.indexOf('mailto:') === 0);
}